"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var FocusBoomerang = function FocusBoomerang() {
  this.returnFocusTarget = null;
};

// Basic focus management for overlay-style elements.
// Triggers focus on the element if it has just become active,
// and returns focus from whence it came if it has just become inactive.
// Works great with React's componentDidUpdate.
FocusBoomerang.prototype.check = function (_ref) {
  var wasActive = _ref.wasActive,
    isActive = _ref.isActive,
    focusedWhenActive = _ref.focusedWhenActive;
  if (!wasActive && isActive) {
    this.returnFocusTarget = document.activeElement;
    focusedWhenActive && focusedWhenActive.focus();
  }
  if (wasActive && !isActive && this.returnFocusTarget) {
    this.returnFocusTarget.focus();
  }
};
var _default = exports["default"] = FocusBoomerang;